// Libs
import classNames from 'classnames/bind';
import { Button, Flex, Heading, IconRefreshLine, Spinner, Text } from '@instructure/ui';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { useAppDispatch, useAppSelector } from '~/utils/redux/hooks';
import { getProfile } from '~/thunks/user/userThunk';
// Styles, images, icons
import styles from './CourseProgram.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const CourseProgram = (props: Props) => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/home', 'common/base', 'common/course']);
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  const {
    profile: userProfile,
    isLoading: isLoadingProfile,
    errorMessage: errorMessageProfile,
  } = useAppSelector((state) => state.userState);
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetProfile = async () => {
    await dispatch(getProfile()).unwrap();
  };

  const renderStudyCourseProgram = () => {
    if (isLoadingProfile && !userProfile) {
      return (
        <div className={cx('centerContainer')}>
          <Spinner size='small' />
        </div>
      );
    }

    if (errorMessageProfile && !userProfile) {
      return (
        <div className={cx('centerContainer')}>
          <Flex justifyItems='center' margin='medium 0'>
            <Button
              onClick={handleGetProfile}
              size='medium'
              color='primary'
              margin='x-large 0 0 0'
              renderIcon={<IconRefreshLine />}
            >
              {t('retry_button_label', { ns: 'common/base' })}
            </Button>
          </Flex>
        </div>
      );
    }

    return (
      <>
        <div className={cx('header')}>
          <Heading level='h3'>{t('study_courses_program_title')}</Heading>

          {/* {userProfile?.fieldOfStudy && (
            <div className={cx('teacherContainer')}>
              <img
                src={userProfile?.teacher?.avatarUrl}
                alt={t('common_alt_img', { ns: 'common/base' })}
                className={cx('avatar')}
              />

              <Flex direction='row' margin='small 0 0 0'>
                <img
                  src={icons.commonIconTeacher}
                  alt={t('common_alt_img', { ns: 'common/base' })}
                  className={cx('userIcon')}
                />

                <Flex direction='row' gap={'small'}>
                  <Text variant='contentImportant'>{t('study_courses_program_teacher_name')}</Text>
                  <Text variant='content'>{userProfile?.teacher?.name}</Text>
                </Flex>
              </Flex>
            </div>
          )} */}
        </div>

        {userProfile?.fieldOfStudy ? (
          <Flex justifyItems='center' alignItems='center' width={'100%'} height={'100%'}>
            <Heading level='h4'>{userProfile.fieldOfStudy}</Heading>
          </Flex>
        ) : (
          <div className={cx('centerContainer')}>
            <Flex justifyItems='center' alignItems='center'>
              <Text variant='contentSmall'>{t('course_detail_no_course_assigned', { ns: 'common/home' })}</Text>
            </Flex>
          </div>
        )}
      </>
    );
  };
  //#endregion Handle Function

  return <>{renderStudyCourseProgram()}</>;
};

export default CourseProgram;
